var _rect, _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 7.15789,
    fill: "#E1E506"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V34H34V0H0Z",
    fill: "#1C8FF8",
    fillOpacity: 0.338428
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3467 23.9512V22.4065C23.3467 20.7002 21.9259 19.3171 20.1733 19.3171H13.8267C12.0741 19.3171 10.6533 20.7002 10.6533 22.4065V23.9512",
    stroke: "white",
    strokeWidth: 0.906667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 13.1383,
    rx: 3.17333,
    ry: 3.08938,
    stroke: "white",
    strokeWidth: 0.906667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.60ee1abb5c2ad8e7cdb9a0cd796bc214.svg";
export { ForwardRef as ReactComponent };